import { Injectable } from '@angular/core';
import { ProfileApiService } from '@fantaz/shared/data-access/api';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import * as SuggestionsActions from './suggestions.actions';

@Injectable()
export class SuggestionsEffects {
  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SuggestionsActions.init),
      switchMap(() => {
        return this.profileApiService.fetchAllSuggestions().pipe(
          map((response) => {
            return SuggestionsActions.loadSuggestionsSuccess({
              suggestions: response.suggestions,
            });
          }),
          catchError((error) => {
            return of(SuggestionsActions.loadSuggestionsFailure({ error }));
          }),
        );
      }),
    ),
  );

  constructor(
    private readonly actions$: Actions,
    private readonly profileApiService: ProfileApiService,
  ) {}
}
